import { render, staticRenderFns } from "./CreateSensor.vue?vue&type=template&id=33baaf42&scoped=true&"
import script from "./CreateSensor.vue?vue&type=script&lang=js&"
export * from "./CreateSensor.vue?vue&type=script&lang=js&"
import style0 from "./CreateSensor.vue?vue&type=style&index=0&id=33baaf42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33baaf42",
  null
  
)

export default component.exports